import { Platform, StyleSheet } from 'react-native';
import Typography from '../../../../shared/constants/Typography';

/**
 * @param isZoomed extreme browser zoom (320x256 CSS px at 400%): the dialog's
 *   512 px minimum width cannot fit, so it fills the viewport, scrolls if taller
 *   than the viewport and wraps its buttons. Never true on native / at normal
 *   desktop widths.
 */
export const globalErrorModalStyles = (theme: any, isZoomed: boolean = false) => {
  const base = StyleSheet.create({
    container: {
      flex: 1,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      backgroundColor: Platform.OS === 'ios' ? theme.background : theme.lightBackground,
      zIndex: Platform.OS === 'web' ? 9999 : 0,
      borderColor: theme.borderColor,
      borderWidth: Typography.borderWidth.borderWidth1,
    },
    modal: {
      backgroundColor: theme.modalBG,
      paddingHorizontal: Typography.padding.padding24,
      borderRadius: Typography.radius.radius8,
      minWidth: Typography.width.width512,
      borderColor: theme.borderColor,
      borderWidth: Typography.borderWidth.borderWidth1,
    },
    header: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.spaceBetween,
      alignItems: Typography.textAlign.centerAlign,
      paddingVertical: Typography.padding.padding16,
      maxWidth: Typography.width.width549,
    },
    headerTitle: {
      fontSize: Typography.fontSize.fontSize24,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.rethinkSans,
      color: theme.headerText,
      lineHeight: Typography.lineHeight.lineHeight36,
    },
    titleSubContainer: {
      gap: Typography.gap.gap10,
    },
    titleContainer: {
      paddingVertical: Typography.padding.padding16,
      maxWidth: Typography.width.width549,
    },
    headerTitleContainer: {
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap6,
    },
    iconContainer: {
      width: Typography.icon.icon24,
      height: Typography.icon.icon24,
      flexShrink: 0,
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },
    title: {
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize16,
      fontWeight: Typography.fontWeight.regular,
      color: theme.headerText,
      marginBottom: Typography.margin.margin12,
    },
    message: {
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.regular,
      fontFamily: Typography.fontFamily.inter,
      color: theme.headerText,
    },
    buttonContainer: {
      flexDirection: 'row',
      justifyContent: Typography.contentAlign.flexEnd,
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap16,
      paddingVertical: Typography.padding.padding20,
    },
    buttonContainerTextStyles: {
      gap: Typography.gap.gap8,
      alignItems: Typography.textAlign.centerAlign,
    },
    cancelContainerStyle: {
      // backgroundColor: 'transparent',
      // borderColor: theme.cancelBtnBorder,
      borderWidth: Typography.borderWidth.borderWidth1,
    },
    cancelCustomTextStyle: {
      //color: theme.cancelBtnText,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
    },
  });
  if (!isZoomed) {
    return base;
  }
  return {
    ...base,
    ...StyleSheet.create({
      container: {
        ...(base.container as object),
        padding: Typography.padding.padding8,
      },
      modal: {
        ...(base.modal as object),
        minWidth: 0,
        width: '100%',
        maxWidth: '100%',
        maxHeight: 'calc(100vh - 16px)',
        overflowY: 'auto',
        paddingHorizontal: Typography.padding.padding12,
      } as object,
      header: {...(base.header as object), maxWidth: '100%'},
      titleContainer: {...(base.titleContainer as object), maxWidth: '100%'},
      buttonContainer: {
        ...(base.buttonContainer as object),
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
      },
    } as any),
  } as typeof base;
};
